/*eslint-disable */

import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'paypal-payment',
  components: {},
  props: [],
  data() {
    return {
      returnId: '',
      preloader: true,
      paypalPlansData: '',
      subscription_plan: '',
      orderId: '',
      userPaidStatus: Boolean,
      planDetails: '',
      subscription_plan_name: ''
    }
  },
  computed: {
    ...mapGetters([
      'getUserOrderId',
      'getPlanDataState',
      'getPaypalPlanDataDetailsState',
      'getProfileInfo'
    ]),
    getPaypalPlanDetailsFun() {
      this.$store.dispatch('getPaypalSubscriptionPlansDetails').then((res) => {
        this.paypalPlansData = this.$store.getters.getPaypalPlanDataDetailsState.data
        if (res.data.code == '2000') {
          this.subscription_plan_name = res.data.data[0].name
          this.orderId = this.paypalPlansData[0].id
          let data = {
            subscription_plan: this.orderId
          }
          this.$store.dispatch('getPaypalOrderDetails', data).then((res) => {
            this.preloader = true
            if (res.data.code == '2000') {
              this.returnId = res.data.data.paypal_order_id
              localStorage.setItem('ReturnId', this.returnId);
              this.planDetails = res.data.data
              this.preloader = false
              $('.app-loader').hide()
            }
          })
        }
      }).catch((err) => {
        toast.error(err);
      })
    }
  },
  mounted() {
    $('body').removeClass('showoverlay');
    this.getPaypalPlanDetailsFun
    setTimeout(() => {
      this.preloader = false;
      $('.app-loader').hide()
    }, 800);
    // Paypal Button Create
    setTimeout(() => {
        paypal.Buttons({
          createOrder: () => {
            return this.returnId;
          },
          onApprove: () => {
            this.$router.push('/payment/confirm/');
          }
        }).render('#paypal-button-container')
      },
      1000);
  },
  methods: {},
  beforeCreate: function() {
    document.title = 'Oddvega - Payment'
  },
  beforeMount() {
    this.$store.dispatch('getProfile').then((res) => {
      this.userPaidStatus = res.data.data.has_active_subscription
    }).catch((err) => {});
    $('body').removeClass('showoverlay');
  },
  created() {
    if (process.env.VUE_APP_PAYPAL_CLIENT_ID) {
      this.$scriptLoader.load("https://www.paypal.com/sdk/js?client-id=" + process.env.VUE_APP_PAYPAL_CLIENT_ID)
    }
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}